import {useEffect, useRef, useMemo} from 'react';
import {debounce} from "@mui/material";


export const useDebounce = (callback: () => any, wait: number) => {
    const ref = useRef();

    useEffect(() => {
        // @ts-ignore
        ref.current = callback;
    }, [callback]);

    const debouncedCallback = useMemo(() => {
        const func = () => {
            // @ts-ignore
            ref.current?.();
        };

        return debounce(func, wait);
    }, [wait]);

    return debouncedCallback;
};